import { render, staticRenderFns } from "./AkademieAdmin.vue?vue&type=template&id=cfa68dda&scoped=true"
import script from "./AkademieAdmin.vue?vue&type=script&lang=js"
export * from "./AkademieAdmin.vue?vue&type=script&lang=js"
import style0 from "./AkademieAdmin.vue?vue&type=style&index=0&id=cfa68dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa68dda",
  null
  
)

export default component.exports